import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import VueScrollTo from 'vue-scrollto'

import axios from "axios";
const signalInstance = axios.create({
	baseURL: 'https://signal.afrihost.com/api/',
	withCredentials: true,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
	}
})

if(window && process.env.MIX_SIGNAL_UUID) {


	const searchParams = new URLSearchParams(window.location.search);

	// signal page view
	let l = window.location
	let path = l.pathname
	let source = searchParams.get('utm_source')
	let medium = searchParams.get('utm_medium')
	let campaign = searchParams.get('utm_campaign')

	let event = {
		type: 'page-view',
		value: null,
		path: path,
		meta: null,
		campaign: campaign,
		medium: medium,
		source: source
	}

	signalInstance.post(`/public/project/${process.env.MIX_SIGNAL_UUID}/event`, event)

}

Sentry.init({
    dsn: 'https://3726d6014f9a4468b9ad0dfb7a5679f3@sentry.io/1503590',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
});

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -60,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

import Wizard from './components/Wizard'
new Vue({
    el: '.speed-wizard',
    render: h => h(Wizard)
});

import SpiderModal from '../../spiderman/Modal.vue'
new Vue({
	el: 'spider-modal',
	render: h => h(SpiderModal)
});
